import React from 'react';
import { NavLink } from 'react-router-dom';
import { ArchiveIcon, BuildingIcon, PlugZapIcon, CalendarDaysIcon, FileCogIcon, FolderOpenIcon, LayoutDashboardIcon, PackageOpenIcon, ScaleIcon, TimerIcon, UsersIcon, WorkflowIcon } from 'lucide-react';
import { useDatos } from '../../contexts/DatosContext';
import { diasRestantes } from '../../utils/fechas';
import { plazosVigentes } from '../../utils/consultas';
const ENLACES = [{
  a: '/',
  etiqueta: 'Inicio',
  icono: LayoutDashboardIcon
}, {
  a: '/expedientes',
  etiqueta: 'Expedientes',
  icono: FolderOpenIcon
}, {
  a: '/vencimientos',
  etiqueta: 'Vencimientos',
  icono: TimerIcon,
  alerta: true
}, {
  a: '/calendario',
  etiqueta: 'Calendario',
  icono: CalendarDaysIcon
}, {
  a: '/almacenes',
  etiqueta: 'Almacenes',
  icono: ArchiveIcon
}, {
  a: '/abogados',
  etiqueta: 'Abogados y personal',
  icono: UsersIcon
}];
const ENLACES_CONFIG = [{
  a: '/configuracion/flujos',
  etiqueta: 'Flujos de proceso',
  icono: WorkflowIcon
}, {
  a: '/configuracion/documentos',
  etiqueta: 'Catálogo de documentos',
  icono: FileCogIcon
}, {
  a: '/configuracion/sucursales',
  etiqueta: 'Sucursales y almacenes',
  icono: BuildingIcon
}, {
  a: '/configuracion/integraciones',
  etiqueta: 'Integraciones',
  icono: PlugZapIcon
}];
export function BarraLateral({
  colapsada = false
}: {
  colapsada?: boolean;
}) {
  const {
    plazos,
    expedientes,
    rol
  } = useDatos();
  const criticos = plazosVigentes(plazos).filter(p => diasRestantes(p.fechaLimite) <= 3).length;
  const prestados = expedientes.filter(e => e.prestadoA).length;
  const claseEnlace = (activo: boolean) => `relative flex items-center rounded text-sm transition-colors duration-150 ${colapsada ? 'h-10 w-10 justify-center' : 'gap-3 px-3 py-2'} ${activo ? 'bg-marino-700 font-semibold text-white' : 'text-marino-100 hover:bg-marino-800 hover:text-white'}`;
  return <aside className={`fixed inset-y-0 left-0 z-20 flex flex-col border-r border-marino-950 bg-marino-900 transition-[width] duration-200 ease-out ${colapsada ? 'w-16 items-center' : 'w-60'}`} aria-label="Navegación del despacho" data-id="element-837" data-mp="e7dcsygo9w4b">
      <div className={`flex items-center py-5 ${colapsada ? 'justify-center' : 'gap-3 px-5'}`} title={colapsada ? 'LIMA AMARO · Control documental' : undefined} data-id="element-838" data-mp="e3uqqbpmea5s">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded bg-ambar-400" data-id="element-839" data-mp="97e6vtpgehyi">
          <ScaleIcon className="h-5 w-5 text-marino-900" aria-hidden="true" data-id="element-840" data-mp="559a4m3pl57n" />
        </span>
        {!colapsada && <div className="leading-tight" data-id="element-841" data-mp="3rircaazxlrut">
            <p className="text-sm font-semibold tracking-wide text-white" data-id="element-842" data-mp="3rjiy4u3q8b7w">LIMA AMARO</p>
            <p className="text-2xs uppercase tracking-wide text-marino-300" data-id="element-843" data-mp="3ml92kie3b8lr">Control documental</p>
          </div>}
      </div>

      <nav aria-label="Navegación principal" className={`flex-1 ${colapsada ? 'px-2' : 'px-3'}`} data-id="element-844" data-mp="3hmxqs248io0w">
        <ul className="space-y-0.5" data-id="element-845" data-mp="3dlcjcwagz1y3">
          {ENLACES.map(({
          a,
          etiqueta,
          icono: Icono,
          alerta
        }) => <li key={a} data-id="element-846" data-mp="1t3jtbrgcba03">
              <NavLink to={a} end={a === '/'} title={colapsada ? etiqueta : undefined} className={({
            isActive
          }) => claseEnlace(isActive)} data-id="element-847" data-mp="1x29gucv3e7xg">
                <Icono className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-848" data-mp="26zxf3crwpxkd" />
                {colapsada ? <>
                    <span className="sr-only" data-id="element-849" data-mp="19f1bjuxnyyvf">{etiqueta}</span>
                    {alerta && criticos > 0 && <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-ambar-400" aria-hidden="true" data-id="element-850" data-mp="1ea87ggkoyz9s" />}
                  </> : <>
                    <span className="flex-1" data-id="element-851" data-mp="qm76bspuel4e">{etiqueta}</span>
                    {alerta && criticos > 0 && <span className="tabular rounded bg-ambar-400 px-1.5 py-0.5 text-2xs font-bold text-marino-900" data-id="element-852" data-mp="vjyviez3rt4w">
                        {criticos}
                      </span>}
                  </>}
              </NavLink>
            </li>)}
        </ul>

        {rol === 'Administrador' && <>
            {colapsada ? <span className="my-3 block h-px bg-marino-800" aria-hidden="true" data-id="element-853" data-mp="328iqnlxbp428" /> : <p className="mt-6 px-3 text-2xs font-semibold uppercase tracking-wide text-marino-400" data-id="element-854" data-mp="3gx57js2lm3vk">
                Configuración
              </p>}
            <ul className="mt-1 space-y-0.5" data-id="element-855" data-mp="3pzwog7e8trul">
              {ENLACES_CONFIG.map(({
            a,
            etiqueta,
            icono: Icono
          }) => <li key={a} data-id="element-856" data-mp="3l1v3fgx9bigh">
                  <NavLink to={a} title={colapsada ? etiqueta : undefined} className={({
              isActive
            }) => claseEnlace(isActive)} data-id="element-857" data-mp="3kygyq214ex5v">
                    <Icono className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-858" data-mp="1qowx18eoh5yf" />
                    {colapsada ? <span className="sr-only" data-id="element-859" data-mp="66ky1ccvlzyj">{etiqueta}</span> : etiqueta}
                  </NavLink>
                </li>)}
            </ul>
          </>}
      </nav>

      {colapsada ? <div className="m-2 flex flex-col items-center gap-0.5 rounded border border-marino-800 bg-marino-950 px-2 py-2" title={`${prestados} expedientes prestados sin devolución registrada`} data-id="element-860" data-mp="3tfrccug1khyt">
          <PackageOpenIcon className="h-4 w-4 text-marino-300" aria-hidden="true" data-id="element-861" data-mp="3oj0ovm1wqk3d" />
          <span className="tabular text-2xs font-semibold text-white" data-id="element-862" data-mp="3aipysl8f99j9">{prestados}</span>
          <span className="sr-only" data-id="element-863" data-mp="3al2ojkkf8o6v">expedientes prestados sin devolver</span>
        </div> : <div className="m-3 rounded border border-marino-800 bg-marino-950 px-3 py-3" data-id="element-864" data-mp="3em4mly2lqu79">
          <p className="text-2xs uppercase tracking-wide text-marino-300" data-id="element-865" data-mp="18p8u9qfl8osq">Archivo físico</p>
          <p className="mt-1 text-sm text-white" data-id="element-866" data-mp="1cqubfnz5np8q">
            <span className="tabular font-semibold" data-id="element-867" data-mp="2lq58fb61mn7r">{prestados}</span> expedientes prestados
          </p>
          <p className="mt-0.5 text-2xs text-marino-300" data-id="element-868" data-mp="2gqis2sux4quq">sin devolución registrada</p>
        </div>}
    </aside>;
}